var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B56738AB-512E-43E3-83DE-B6EC2A81B47A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.1_Library_18",
    transform: "translate(-1363.000000, -564.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(260.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Small-Button",
    transform: "translate(1044.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(59.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08510638,4.54551004 L4.08510638,13.8635809 C4.08510638,15.9935968 5.81632315,17.7272727 7.94331783,17.7272727 L7.94331783,17.7272727 L16.3404255,17.7272727 L16.3404255,19.3181263 C16.3404255,20.6972434 15.2210771,21.8181818 13.8439162,21.8181818 L13.8439162,21.8181818 L2.49650932,21.8181818 C1.11934843,21.8181818 -3.55271368e-15,20.6972434 -3.55271368e-15,19.3181263 L-3.55271368e-15,19.3181263 L-3.55271368e-15,7.04539905 C-3.55271368e-15,5.66628196 1.11934843,4.54551004 2.49650932,4.54551004 L2.49650932,4.54551004 L4.08510638,4.54551004 Z M17.4752327,1.77635684e-15 C18.8540558,1.77635684e-15 19.9715758,1.11910734 19.9715758,2.5000555 L19.9715758,2.5000555 L19.9715758,13.8635809 C19.9715758,15.244529 18.8540558,16.3636364 17.4752327,16.3636364 L17.4752327,16.3636364 L7.94331783,16.3636364 C6.56432847,16.3636364 5.44680851,15.244529 5.44680851,13.8635809 L5.44680851,13.8635809 L5.44680851,2.5000555 C5.44680851,1.11910734 6.56432847,1.77635684e-15 7.94331783,1.77635684e-15 L7.94331783,1.77635684e-15 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.5c509c500e3197ab78888a366d6b195b.svg";
export { ForwardRef as ReactComponent };